import { render, staticRenderFns } from "./funding_record.vue?vue&type=template&id=77b6b128&scoped=true"
import script from "./funding_record.vue?vue&type=script&lang=js"
export * from "./funding_record.vue?vue&type=script&lang=js"
import style0 from "./funding_record.vue?vue&type=style&index=0&id=77b6b128&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b6b128",
  null
  
)

export default component.exports